import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ListaBase } from '../../crud/ListaBase';
import { EstruturaGridViewBuilder } from './../../gridview/EstruturaGridViewBuilder';
import { BarraNotificacaoService } from './../barra-notificacao.service';


@Component({
  selector: 'app-barra-notificacao-lista',
  templateUrl: './barra-notificacao-lista.component.html', 
  styleUrls: ['./barra-notificacao-lista.component.css']
})

export class BarraNotificacaoListaComponent extends ListaBase implements OnInit {

  constructor(service: BarraNotificacaoService, toastr: ToastrService, router: Router) {
    super(service, toastr, router);
    this.listagemComPaginacao = true;
    this.quantidadeRegistrosPorPagina = 5;
  }

  ngOnInit() {
    this.buscar();
    this.estrutura = new EstruturaGridViewBuilder()
    .addColunaCentralizadaW('id', 'ID', '40px')
    .addColuna('descricao', 'Descrição')
    .build();
  }

  protected getListagemComFiltros(): boolean {
    return false;
  }

  protected getDados(dados: any): any {
    return dados.notas;
  }

  definirCollapse(item: any) {
    item.collapse = !item.collapse;
  }

}